import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns a CSS `color-mix()` value that applies the given opacity
 * to a design-system color token.
 *
 * Uses oklch mixing space to match the token system's perceptual uniformity.
 *
 * @param token  - CSS variable name, e.g. `"--primary"` or `"--error"`
 * @param opacity - A number between 0 and 1 (0 = fully transparent, 1 = opaque)
 * @returns A CSS value string usable in any color property
 *
 * @example
 * // inline style
 * <div style={{ background: colorToken("--primary", 0.5) }} />
 *
 * // equivalent to: color-mix(in oklch, var(--primary) 50%, transparent)
 */
export function colorToken(token: string, opacity: number = 1): string {
  const pct = Math.round(Math.min(1, Math.max(0, opacity)) * 100)
  if (pct === 100) return `var(${token})`
  return `color-mix(in oklch, var(${token}) ${pct}%, transparent)`
}
